
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");

















var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$export$9f275aff884e1431 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeContentToolsItem(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : function ForgeContentToolsItem({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
};
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
const $0c33e41081c1500e$var$ForgeUIExtensionLoader = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
} : function ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                type: (0, $hIaUw.getContentType)(routeName)
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        }
    }));
};
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("bLJKG"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("ajkcO"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("fERdC"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("cxmc2"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("3yRTK"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("6XH8W"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("8Hg0P"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("3cuCl"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("8mnDj"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("6pHE5"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("a4qRq"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("047XR"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("bLJKG", function(module, exports) {

let $891792db92a0579a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $891792db92a0579a$var$load("2YffH"),
    $891792db92a0579a$var$load("8Kivm"),
    $891792db92a0579a$var$load("1V9QO"),
    $891792db92a0579a$var$load("j03h9"),
    $891792db92a0579a$var$load("iQ0Jm"),
    $891792db92a0579a$var$load("coJiW"),
    $891792db92a0579a$var$load("eiooB"),
    $891792db92a0579a$var$load("iLyOq"),
    $891792db92a0579a$var$load("h4Nf7"),
    $891792db92a0579a$var$load("7f9Fz"),
    $891792db92a0579a$var$load("8YSo7"),
    $891792db92a0579a$var$load("lYvov"),
    $891792db92a0579a$var$load("k8XPW"),
    $891792db92a0579a$var$load("fWCRm"),
    $891792db92a0579a$var$load("g9CVe"),
    $891792db92a0579a$var$load("aeEUI"),
    $891792db92a0579a$var$load("hRUX7"),
    $891792db92a0579a$var$load("g4oYs"),
    $891792db92a0579a$var$load("6wr18"),
    $891792db92a0579a$var$load("kjZZD"),
    $891792db92a0579a$var$load("3ySTn"),
    $891792db92a0579a$var$load("c2rHL"),
    $891792db92a0579a$var$load("awqCy"),
    $891792db92a0579a$var$load("kHOMt"),
    $891792db92a0579a$var$load("hhss7"),
    $891792db92a0579a$var$load("6kZfp"),
    $891792db92a0579a$var$load("2UbDA"),
    $891792db92a0579a$var$load("nbjnv"),
    $891792db92a0579a$var$load("Wowvf"),
    $891792db92a0579a$var$load("ffEVr"),
    $891792db92a0579a$var$load("jlSv2"),
    $891792db92a0579a$var$load("1UUrt"),
    $891792db92a0579a$var$load("jSdjl"),
    $891792db92a0579a$var$load("l2EUC"),
    $891792db92a0579a$var$load("kWZnd"),
    $891792db92a0579a$var$load("92LGf"),
    $891792db92a0579a$var$load("let0D"),
    $891792db92a0579a$var$load("joFPh"),
    $891792db92a0579a$var$load("b7jBL"),
    $891792db92a0579a$var$load("kUbUu"),
    $891792db92a0579a$var$load("2PePB"),
    $891792db92a0579a$var$load("1W4KB"),
    $891792db92a0579a$var$load("lnKog"),
    $891792db92a0579a$var$load("9ftJe"),
    $891792db92a0579a$var$load("h3ABO"),
    $891792db92a0579a$var$load("kC80R"),
    $891792db92a0579a$var$load("7EorR"),
    $891792db92a0579a$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("ajkcO", function(module, exports) {

let $781b5a2302657759$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $781b5a2302657759$var$load("2YffH"),
    $781b5a2302657759$var$load("8Kivm"),
    $781b5a2302657759$var$load("1V9QO"),
    $781b5a2302657759$var$load("j03h9"),
    $781b5a2302657759$var$load("iQ0Jm"),
    $781b5a2302657759$var$load("coJiW"),
    $781b5a2302657759$var$load("eiooB"),
    $781b5a2302657759$var$load("iLyOq"),
    $781b5a2302657759$var$load("h4Nf7"),
    $781b5a2302657759$var$load("7f9Fz"),
    $781b5a2302657759$var$load("8YSo7"),
    $781b5a2302657759$var$load("lYvov"),
    $781b5a2302657759$var$load("k8XPW"),
    $781b5a2302657759$var$load("fWCRm"),
    $781b5a2302657759$var$load("g9CVe"),
    $781b5a2302657759$var$load("aeEUI"),
    $781b5a2302657759$var$load("hRUX7"),
    $781b5a2302657759$var$load("g4oYs"),
    $781b5a2302657759$var$load("6wr18"),
    $781b5a2302657759$var$load("kjZZD"),
    $781b5a2302657759$var$load("3ySTn"),
    $781b5a2302657759$var$load("c2rHL"),
    $781b5a2302657759$var$load("awqCy"),
    $781b5a2302657759$var$load("kHOMt"),
    $781b5a2302657759$var$load("hhss7"),
    $781b5a2302657759$var$load("6kZfp"),
    $781b5a2302657759$var$load("2UbDA"),
    $781b5a2302657759$var$load("nbjnv"),
    $781b5a2302657759$var$load("Wowvf"),
    $781b5a2302657759$var$load("ffEVr"),
    $781b5a2302657759$var$load("jlSv2"),
    $781b5a2302657759$var$load("1UUrt"),
    $781b5a2302657759$var$load("jSdjl"),
    $781b5a2302657759$var$load("l2EUC"),
    $781b5a2302657759$var$load("kWZnd"),
    $781b5a2302657759$var$load("92LGf"),
    $781b5a2302657759$var$load("let0D"),
    $781b5a2302657759$var$load("joFPh"),
    $781b5a2302657759$var$load("b7jBL"),
    $781b5a2302657759$var$load("kUbUu"),
    $781b5a2302657759$var$load("2PePB"),
    $781b5a2302657759$var$load("1W4KB"),
    $781b5a2302657759$var$load("lnKog"),
    $781b5a2302657759$var$load("9ftJe"),
    $781b5a2302657759$var$load("h3ABO"),
    $781b5a2302657759$var$load("kC80R"),
    $781b5a2302657759$var$load("7EorR"),
    $781b5a2302657759$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("fERdC", function(module, exports) {

let $b663df8f7fa5abe9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b663df8f7fa5abe9$var$load("2YffH"),
    $b663df8f7fa5abe9$var$load("8Kivm"),
    $b663df8f7fa5abe9$var$load("1V9QO"),
    $b663df8f7fa5abe9$var$load("j03h9"),
    $b663df8f7fa5abe9$var$load("iQ0Jm"),
    $b663df8f7fa5abe9$var$load("coJiW"),
    $b663df8f7fa5abe9$var$load("eiooB"),
    $b663df8f7fa5abe9$var$load("iLyOq"),
    $b663df8f7fa5abe9$var$load("h4Nf7"),
    $b663df8f7fa5abe9$var$load("7f9Fz"),
    $b663df8f7fa5abe9$var$load("8YSo7"),
    $b663df8f7fa5abe9$var$load("lYvov"),
    $b663df8f7fa5abe9$var$load("k8XPW"),
    $b663df8f7fa5abe9$var$load("fWCRm"),
    $b663df8f7fa5abe9$var$load("g9CVe"),
    $b663df8f7fa5abe9$var$load("aeEUI"),
    $b663df8f7fa5abe9$var$load("hRUX7"),
    $b663df8f7fa5abe9$var$load("g4oYs"),
    $b663df8f7fa5abe9$var$load("6wr18"),
    $b663df8f7fa5abe9$var$load("kjZZD"),
    $b663df8f7fa5abe9$var$load("3ySTn"),
    $b663df8f7fa5abe9$var$load("c2rHL"),
    $b663df8f7fa5abe9$var$load("awqCy"),
    $b663df8f7fa5abe9$var$load("kHOMt"),
    $b663df8f7fa5abe9$var$load("hhss7"),
    $b663df8f7fa5abe9$var$load("6kZfp"),
    $b663df8f7fa5abe9$var$load("2UbDA"),
    $b663df8f7fa5abe9$var$load("nbjnv"),
    $b663df8f7fa5abe9$var$load("Wowvf"),
    $b663df8f7fa5abe9$var$load("ffEVr"),
    $b663df8f7fa5abe9$var$load("jlSv2"),
    $b663df8f7fa5abe9$var$load("1UUrt"),
    $b663df8f7fa5abe9$var$load("jSdjl"),
    $b663df8f7fa5abe9$var$load("l2EUC"),
    $b663df8f7fa5abe9$var$load("kWZnd"),
    $b663df8f7fa5abe9$var$load("92LGf"),
    $b663df8f7fa5abe9$var$load("let0D"),
    $b663df8f7fa5abe9$var$load("joFPh"),
    $b663df8f7fa5abe9$var$load("b7jBL"),
    $b663df8f7fa5abe9$var$load("kUbUu"),
    $b663df8f7fa5abe9$var$load("2PePB"),
    $b663df8f7fa5abe9$var$load("1W4KB"),
    $b663df8f7fa5abe9$var$load("lnKog"),
    $b663df8f7fa5abe9$var$load("9ftJe"),
    $b663df8f7fa5abe9$var$load("h3ABO"),
    $b663df8f7fa5abe9$var$load("kC80R"),
    $b663df8f7fa5abe9$var$load("7EorR"),
    $b663df8f7fa5abe9$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("cxmc2", function(module, exports) {

let $9209c82d8a25ee38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9209c82d8a25ee38$var$load("k8XPW"),
    $9209c82d8a25ee38$var$load("fWCRm"),
    $9209c82d8a25ee38$var$load("2YffH"),
    $9209c82d8a25ee38$var$load("2PePB"),
    $9209c82d8a25ee38$var$load("1V9QO"),
    $9209c82d8a25ee38$var$load("j03h9"),
    $9209c82d8a25ee38$var$load("eiooB"),
    $9209c82d8a25ee38$var$load("iLyOq"),
    $9209c82d8a25ee38$var$load("h4Nf7"),
    $9209c82d8a25ee38$var$load("7f9Fz"),
    $9209c82d8a25ee38$var$load("8YSo7"),
    $9209c82d8a25ee38$var$load("lYvov"),
    $9209c82d8a25ee38$var$load("g9CVe"),
    $9209c82d8a25ee38$var$load("aeEUI"),
    $9209c82d8a25ee38$var$load("hRUX7"),
    $9209c82d8a25ee38$var$load("g4oYs"),
    $9209c82d8a25ee38$var$load("6wr18"),
    $9209c82d8a25ee38$var$load("kjZZD"),
    $9209c82d8a25ee38$var$load("3ySTn"),
    $9209c82d8a25ee38$var$load("c2rHL"),
    $9209c82d8a25ee38$var$load("awqCy"),
    $9209c82d8a25ee38$var$load("kHOMt"),
    $9209c82d8a25ee38$var$load("hhss7"),
    $9209c82d8a25ee38$var$load("6kZfp"),
    $9209c82d8a25ee38$var$load("2UbDA"),
    $9209c82d8a25ee38$var$load("nbjnv"),
    $9209c82d8a25ee38$var$load("Wowvf"),
    $9209c82d8a25ee38$var$load("ffEVr"),
    $9209c82d8a25ee38$var$load("jlSv2"),
    $9209c82d8a25ee38$var$load("1UUrt"),
    $9209c82d8a25ee38$var$load("jSdjl"),
    $9209c82d8a25ee38$var$load("l2EUC"),
    $9209c82d8a25ee38$var$load("kWZnd"),
    $9209c82d8a25ee38$var$load("92LGf"),
    $9209c82d8a25ee38$var$load("let0D"),
    $9209c82d8a25ee38$var$load("joFPh"),
    $9209c82d8a25ee38$var$load("b7jBL"),
    $9209c82d8a25ee38$var$load("1W4KB"),
    $9209c82d8a25ee38$var$load("kUbUu"),
    $9209c82d8a25ee38$var$load("9ftJe"),
    $9209c82d8a25ee38$var$load("h3ABO"),
    $9209c82d8a25ee38$var$load("kC80R"),
    $9209c82d8a25ee38$var$load("7EorR"),
    $9209c82d8a25ee38$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("3yRTK", function(module, exports) {

let $297e5b2282f751dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $297e5b2282f751dd$var$load("k8XPW"),
    $297e5b2282f751dd$var$load("fWCRm"),
    $297e5b2282f751dd$var$load("2YffH"),
    $297e5b2282f751dd$var$load("2PePB"),
    $297e5b2282f751dd$var$load("1V9QO"),
    $297e5b2282f751dd$var$load("j03h9"),
    $297e5b2282f751dd$var$load("eiooB"),
    $297e5b2282f751dd$var$load("iLyOq"),
    $297e5b2282f751dd$var$load("h4Nf7"),
    $297e5b2282f751dd$var$load("7f9Fz"),
    $297e5b2282f751dd$var$load("8YSo7"),
    $297e5b2282f751dd$var$load("lYvov"),
    $297e5b2282f751dd$var$load("g9CVe"),
    $297e5b2282f751dd$var$load("aeEUI"),
    $297e5b2282f751dd$var$load("hRUX7"),
    $297e5b2282f751dd$var$load("g4oYs"),
    $297e5b2282f751dd$var$load("6wr18"),
    $297e5b2282f751dd$var$load("kjZZD"),
    $297e5b2282f751dd$var$load("3ySTn"),
    $297e5b2282f751dd$var$load("c2rHL"),
    $297e5b2282f751dd$var$load("awqCy"),
    $297e5b2282f751dd$var$load("kHOMt"),
    $297e5b2282f751dd$var$load("hhss7"),
    $297e5b2282f751dd$var$load("6kZfp"),
    $297e5b2282f751dd$var$load("2UbDA"),
    $297e5b2282f751dd$var$load("nbjnv"),
    $297e5b2282f751dd$var$load("Wowvf"),
    $297e5b2282f751dd$var$load("ffEVr"),
    $297e5b2282f751dd$var$load("jlSv2"),
    $297e5b2282f751dd$var$load("1UUrt"),
    $297e5b2282f751dd$var$load("jSdjl"),
    $297e5b2282f751dd$var$load("l2EUC"),
    $297e5b2282f751dd$var$load("kWZnd"),
    $297e5b2282f751dd$var$load("92LGf"),
    $297e5b2282f751dd$var$load("let0D"),
    $297e5b2282f751dd$var$load("joFPh"),
    $297e5b2282f751dd$var$load("b7jBL"),
    $297e5b2282f751dd$var$load("1W4KB"),
    $297e5b2282f751dd$var$load("kUbUu"),
    $297e5b2282f751dd$var$load("9ftJe"),
    $297e5b2282f751dd$var$load("h3ABO"),
    $297e5b2282f751dd$var$load("kC80R"),
    $297e5b2282f751dd$var$load("7EorR"),
    $297e5b2282f751dd$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("6XH8W", function(module, exports) {

let $5119b81ad4b1c56f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5119b81ad4b1c56f$var$load("k8XPW"),
    $5119b81ad4b1c56f$var$load("fWCRm"),
    $5119b81ad4b1c56f$var$load("2YffH"),
    $5119b81ad4b1c56f$var$load("2PePB"),
    $5119b81ad4b1c56f$var$load("1V9QO"),
    $5119b81ad4b1c56f$var$load("j03h9"),
    $5119b81ad4b1c56f$var$load("eiooB"),
    $5119b81ad4b1c56f$var$load("iLyOq"),
    $5119b81ad4b1c56f$var$load("h4Nf7"),
    $5119b81ad4b1c56f$var$load("7f9Fz"),
    $5119b81ad4b1c56f$var$load("8YSo7"),
    $5119b81ad4b1c56f$var$load("lYvov"),
    $5119b81ad4b1c56f$var$load("g9CVe"),
    $5119b81ad4b1c56f$var$load("aeEUI"),
    $5119b81ad4b1c56f$var$load("hRUX7"),
    $5119b81ad4b1c56f$var$load("g4oYs"),
    $5119b81ad4b1c56f$var$load("6wr18"),
    $5119b81ad4b1c56f$var$load("kjZZD"),
    $5119b81ad4b1c56f$var$load("3ySTn"),
    $5119b81ad4b1c56f$var$load("c2rHL"),
    $5119b81ad4b1c56f$var$load("awqCy"),
    $5119b81ad4b1c56f$var$load("kHOMt"),
    $5119b81ad4b1c56f$var$load("hhss7"),
    $5119b81ad4b1c56f$var$load("6kZfp"),
    $5119b81ad4b1c56f$var$load("2UbDA"),
    $5119b81ad4b1c56f$var$load("nbjnv"),
    $5119b81ad4b1c56f$var$load("Wowvf"),
    $5119b81ad4b1c56f$var$load("ffEVr"),
    $5119b81ad4b1c56f$var$load("jlSv2"),
    $5119b81ad4b1c56f$var$load("1UUrt"),
    $5119b81ad4b1c56f$var$load("jSdjl"),
    $5119b81ad4b1c56f$var$load("l2EUC"),
    $5119b81ad4b1c56f$var$load("kWZnd"),
    $5119b81ad4b1c56f$var$load("92LGf"),
    $5119b81ad4b1c56f$var$load("let0D"),
    $5119b81ad4b1c56f$var$load("joFPh"),
    $5119b81ad4b1c56f$var$load("b7jBL"),
    $5119b81ad4b1c56f$var$load("1W4KB"),
    $5119b81ad4b1c56f$var$load("kUbUu"),
    $5119b81ad4b1c56f$var$load("9ftJe"),
    $5119b81ad4b1c56f$var$load("h3ABO"),
    $5119b81ad4b1c56f$var$load("kC80R"),
    $5119b81ad4b1c56f$var$load("7EorR"),
    $5119b81ad4b1c56f$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("8Hg0P", function(module, exports) {

let $654ec294c1cc2e94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $654ec294c1cc2e94$var$load("k8XPW"),
    $654ec294c1cc2e94$var$load("fWCRm"),
    $654ec294c1cc2e94$var$load("2YffH"),
    $654ec294c1cc2e94$var$load("1V9QO"),
    $654ec294c1cc2e94$var$load("j03h9"),
    $654ec294c1cc2e94$var$load("eiooB"),
    $654ec294c1cc2e94$var$load("iLyOq"),
    $654ec294c1cc2e94$var$load("h4Nf7"),
    $654ec294c1cc2e94$var$load("7f9Fz"),
    $654ec294c1cc2e94$var$load("8YSo7"),
    $654ec294c1cc2e94$var$load("lYvov"),
    $654ec294c1cc2e94$var$load("g9CVe"),
    $654ec294c1cc2e94$var$load("aeEUI"),
    $654ec294c1cc2e94$var$load("hRUX7"),
    $654ec294c1cc2e94$var$load("g4oYs"),
    $654ec294c1cc2e94$var$load("6wr18"),
    $654ec294c1cc2e94$var$load("kjZZD"),
    $654ec294c1cc2e94$var$load("3ySTn"),
    $654ec294c1cc2e94$var$load("c2rHL"),
    $654ec294c1cc2e94$var$load("awqCy"),
    $654ec294c1cc2e94$var$load("kHOMt"),
    $654ec294c1cc2e94$var$load("hhss7"),
    $654ec294c1cc2e94$var$load("6kZfp"),
    $654ec294c1cc2e94$var$load("2UbDA"),
    $654ec294c1cc2e94$var$load("nbjnv"),
    $654ec294c1cc2e94$var$load("Wowvf"),
    $654ec294c1cc2e94$var$load("ffEVr"),
    $654ec294c1cc2e94$var$load("jlSv2"),
    $654ec294c1cc2e94$var$load("1UUrt"),
    $654ec294c1cc2e94$var$load("jSdjl"),
    $654ec294c1cc2e94$var$load("l2EUC"),
    $654ec294c1cc2e94$var$load("kWZnd"),
    $654ec294c1cc2e94$var$load("92LGf"),
    $654ec294c1cc2e94$var$load("let0D"),
    $654ec294c1cc2e94$var$load("joFPh"),
    $654ec294c1cc2e94$var$load("b7jBL"),
    $654ec294c1cc2e94$var$load("kUbUu"),
    $654ec294c1cc2e94$var$load("2PePB"),
    $654ec294c1cc2e94$var$load("1W4KB"),
    $654ec294c1cc2e94$var$load("lnKog"),
    $654ec294c1cc2e94$var$load("9ftJe"),
    $654ec294c1cc2e94$var$load("h3ABO"),
    $654ec294c1cc2e94$var$load("kC80R"),
    $654ec294c1cc2e94$var$load("7EorR"),
    $654ec294c1cc2e94$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("3cuCl", function(module, exports) {

let $254a3e1335d9e971$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $254a3e1335d9e971$var$load("2YffH"),
    $254a3e1335d9e971$var$load("1V9QO"),
    $254a3e1335d9e971$var$load("j03h9"),
    $254a3e1335d9e971$var$load("coJiW"),
    $254a3e1335d9e971$var$load("eiooB"),
    $254a3e1335d9e971$var$load("iLyOq"),
    $254a3e1335d9e971$var$load("h4Nf7"),
    $254a3e1335d9e971$var$load("7f9Fz"),
    $254a3e1335d9e971$var$load("8YSo7"),
    $254a3e1335d9e971$var$load("lYvov"),
    $254a3e1335d9e971$var$load("k8XPW"),
    $254a3e1335d9e971$var$load("fWCRm"),
    $254a3e1335d9e971$var$load("g9CVe"),
    $254a3e1335d9e971$var$load("aeEUI"),
    $254a3e1335d9e971$var$load("hRUX7"),
    $254a3e1335d9e971$var$load("g4oYs"),
    $254a3e1335d9e971$var$load("6wr18"),
    $254a3e1335d9e971$var$load("kjZZD"),
    $254a3e1335d9e971$var$load("3ySTn"),
    $254a3e1335d9e971$var$load("c2rHL"),
    $254a3e1335d9e971$var$load("dTsOE"),
    $254a3e1335d9e971$var$load("awqCy"),
    $254a3e1335d9e971$var$load("kHOMt"),
    $254a3e1335d9e971$var$load("hhss7"),
    $254a3e1335d9e971$var$load("6kZfp"),
    $254a3e1335d9e971$var$load("2UbDA"),
    $254a3e1335d9e971$var$load("nbjnv"),
    $254a3e1335d9e971$var$load("Wowvf"),
    $254a3e1335d9e971$var$load("ffEVr"),
    $254a3e1335d9e971$var$load("jlSv2"),
    $254a3e1335d9e971$var$load("1UUrt"),
    $254a3e1335d9e971$var$load("jSdjl"),
    $254a3e1335d9e971$var$load("l2EUC"),
    $254a3e1335d9e971$var$load("kWZnd"),
    $254a3e1335d9e971$var$load("92LGf"),
    $254a3e1335d9e971$var$load("let0D"),
    $254a3e1335d9e971$var$load("joFPh"),
    $254a3e1335d9e971$var$load("b7jBL"),
    $254a3e1335d9e971$var$load("kUbUu"),
    $254a3e1335d9e971$var$load("2PePB"),
    $254a3e1335d9e971$var$load("1W4KB"),
    $254a3e1335d9e971$var$load("lnKog"),
    $254a3e1335d9e971$var$load("9ftJe"),
    $254a3e1335d9e971$var$load("h3ABO"),
    $254a3e1335d9e971$var$load("kC80R"),
    $254a3e1335d9e971$var$load("7EorR"),
    $254a3e1335d9e971$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("8mnDj", function(module, exports) {

let $6162b5d999f10758$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6162b5d999f10758$var$load("2YffH"),
    $6162b5d999f10758$var$load("1V9QO"),
    $6162b5d999f10758$var$load("j03h9"),
    $6162b5d999f10758$var$load("coJiW"),
    $6162b5d999f10758$var$load("eiooB"),
    $6162b5d999f10758$var$load("iLyOq"),
    $6162b5d999f10758$var$load("h4Nf7"),
    $6162b5d999f10758$var$load("7f9Fz"),
    $6162b5d999f10758$var$load("8YSo7"),
    $6162b5d999f10758$var$load("lYvov"),
    $6162b5d999f10758$var$load("k8XPW"),
    $6162b5d999f10758$var$load("fWCRm"),
    $6162b5d999f10758$var$load("g9CVe"),
    $6162b5d999f10758$var$load("aeEUI"),
    $6162b5d999f10758$var$load("hRUX7"),
    $6162b5d999f10758$var$load("g4oYs"),
    $6162b5d999f10758$var$load("6wr18"),
    $6162b5d999f10758$var$load("kjZZD"),
    $6162b5d999f10758$var$load("3ySTn"),
    $6162b5d999f10758$var$load("c2rHL"),
    $6162b5d999f10758$var$load("dTsOE"),
    $6162b5d999f10758$var$load("awqCy"),
    $6162b5d999f10758$var$load("kHOMt"),
    $6162b5d999f10758$var$load("hhss7"),
    $6162b5d999f10758$var$load("6kZfp"),
    $6162b5d999f10758$var$load("2UbDA"),
    $6162b5d999f10758$var$load("nbjnv"),
    $6162b5d999f10758$var$load("Wowvf"),
    $6162b5d999f10758$var$load("ffEVr"),
    $6162b5d999f10758$var$load("jlSv2"),
    $6162b5d999f10758$var$load("1UUrt"),
    $6162b5d999f10758$var$load("jSdjl"),
    $6162b5d999f10758$var$load("l2EUC"),
    $6162b5d999f10758$var$load("kWZnd"),
    $6162b5d999f10758$var$load("92LGf"),
    $6162b5d999f10758$var$load("let0D"),
    $6162b5d999f10758$var$load("joFPh"),
    $6162b5d999f10758$var$load("b7jBL"),
    $6162b5d999f10758$var$load("kUbUu"),
    $6162b5d999f10758$var$load("2PePB"),
    $6162b5d999f10758$var$load("1W4KB"),
    $6162b5d999f10758$var$load("lnKog"),
    $6162b5d999f10758$var$load("9ftJe"),
    $6162b5d999f10758$var$load("h3ABO"),
    $6162b5d999f10758$var$load("kC80R"),
    $6162b5d999f10758$var$load("7EorR"),
    $6162b5d999f10758$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("6pHE5", function(module, exports) {

let $4ab6eef9b4b2faa3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4ab6eef9b4b2faa3$var$load("k8XPW"),
    $4ab6eef9b4b2faa3$var$load("fWCRm"),
    $4ab6eef9b4b2faa3$var$load("2YffH"),
    $4ab6eef9b4b2faa3$var$load("2PePB"),
    $4ab6eef9b4b2faa3$var$load("1V9QO"),
    $4ab6eef9b4b2faa3$var$load("j03h9"),
    $4ab6eef9b4b2faa3$var$load("eiooB"),
    $4ab6eef9b4b2faa3$var$load("iLyOq"),
    $4ab6eef9b4b2faa3$var$load("h4Nf7"),
    $4ab6eef9b4b2faa3$var$load("7f9Fz"),
    $4ab6eef9b4b2faa3$var$load("8YSo7"),
    $4ab6eef9b4b2faa3$var$load("lYvov"),
    $4ab6eef9b4b2faa3$var$load("g9CVe"),
    $4ab6eef9b4b2faa3$var$load("aeEUI"),
    $4ab6eef9b4b2faa3$var$load("hRUX7"),
    $4ab6eef9b4b2faa3$var$load("g4oYs"),
    $4ab6eef9b4b2faa3$var$load("6wr18"),
    $4ab6eef9b4b2faa3$var$load("kjZZD"),
    $4ab6eef9b4b2faa3$var$load("3ySTn"),
    $4ab6eef9b4b2faa3$var$load("c2rHL"),
    $4ab6eef9b4b2faa3$var$load("awqCy"),
    $4ab6eef9b4b2faa3$var$load("kHOMt"),
    $4ab6eef9b4b2faa3$var$load("hhss7"),
    $4ab6eef9b4b2faa3$var$load("6kZfp"),
    $4ab6eef9b4b2faa3$var$load("2UbDA"),
    $4ab6eef9b4b2faa3$var$load("nbjnv"),
    $4ab6eef9b4b2faa3$var$load("Wowvf"),
    $4ab6eef9b4b2faa3$var$load("ffEVr"),
    $4ab6eef9b4b2faa3$var$load("jlSv2"),
    $4ab6eef9b4b2faa3$var$load("1UUrt"),
    $4ab6eef9b4b2faa3$var$load("jSdjl"),
    $4ab6eef9b4b2faa3$var$load("l2EUC"),
    $4ab6eef9b4b2faa3$var$load("kWZnd"),
    $4ab6eef9b4b2faa3$var$load("92LGf"),
    $4ab6eef9b4b2faa3$var$load("let0D"),
    $4ab6eef9b4b2faa3$var$load("joFPh"),
    $4ab6eef9b4b2faa3$var$load("b7jBL"),
    $4ab6eef9b4b2faa3$var$load("1W4KB"),
    $4ab6eef9b4b2faa3$var$load("kUbUu"),
    $4ab6eef9b4b2faa3$var$load("9ftJe"),
    $4ab6eef9b4b2faa3$var$load("h3ABO"),
    $4ab6eef9b4b2faa3$var$load("kC80R"),
    $4ab6eef9b4b2faa3$var$load("7EorR"),
    $4ab6eef9b4b2faa3$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("a4qRq", function(module, exports) {

let $754f1d174dd7cc8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $754f1d174dd7cc8a$var$load("k8XPW"),
    $754f1d174dd7cc8a$var$load("fWCRm"),
    $754f1d174dd7cc8a$var$load("2YffH"),
    $754f1d174dd7cc8a$var$load("1V9QO"),
    $754f1d174dd7cc8a$var$load("j03h9"),
    $754f1d174dd7cc8a$var$load("eiooB"),
    $754f1d174dd7cc8a$var$load("iLyOq"),
    $754f1d174dd7cc8a$var$load("h4Nf7"),
    $754f1d174dd7cc8a$var$load("7f9Fz"),
    $754f1d174dd7cc8a$var$load("8YSo7"),
    $754f1d174dd7cc8a$var$load("lYvov"),
    $754f1d174dd7cc8a$var$load("g9CVe"),
    $754f1d174dd7cc8a$var$load("aeEUI"),
    $754f1d174dd7cc8a$var$load("hRUX7"),
    $754f1d174dd7cc8a$var$load("g4oYs"),
    $754f1d174dd7cc8a$var$load("6wr18"),
    $754f1d174dd7cc8a$var$load("kjZZD"),
    $754f1d174dd7cc8a$var$load("3ySTn"),
    $754f1d174dd7cc8a$var$load("c2rHL"),
    $754f1d174dd7cc8a$var$load("awqCy"),
    $754f1d174dd7cc8a$var$load("kHOMt"),
    $754f1d174dd7cc8a$var$load("hhss7"),
    $754f1d174dd7cc8a$var$load("6kZfp"),
    $754f1d174dd7cc8a$var$load("2UbDA"),
    $754f1d174dd7cc8a$var$load("nbjnv"),
    $754f1d174dd7cc8a$var$load("Wowvf"),
    $754f1d174dd7cc8a$var$load("ffEVr"),
    $754f1d174dd7cc8a$var$load("jlSv2"),
    $754f1d174dd7cc8a$var$load("1UUrt"),
    $754f1d174dd7cc8a$var$load("jSdjl"),
    $754f1d174dd7cc8a$var$load("l2EUC"),
    $754f1d174dd7cc8a$var$load("kWZnd"),
    $754f1d174dd7cc8a$var$load("92LGf"),
    $754f1d174dd7cc8a$var$load("let0D"),
    $754f1d174dd7cc8a$var$load("joFPh"),
    $754f1d174dd7cc8a$var$load("b7jBL"),
    $754f1d174dd7cc8a$var$load("kUbUu"),
    $754f1d174dd7cc8a$var$load("2PePB"),
    $754f1d174dd7cc8a$var$load("1W4KB"),
    $754f1d174dd7cc8a$var$load("lnKog"),
    $754f1d174dd7cc8a$var$load("9ftJe"),
    $754f1d174dd7cc8a$var$load("h3ABO"),
    $754f1d174dd7cc8a$var$load("kC80R"),
    $754f1d174dd7cc8a$var$load("7EorR"),
    $754f1d174dd7cc8a$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("047XR", function(module, exports) {

let $00c68d69912bfe4e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00c68d69912bfe4e$var$load("k8XPW"),
    $00c68d69912bfe4e$var$load("fWCRm"),
    $00c68d69912bfe4e$var$load("2YffH"),
    $00c68d69912bfe4e$var$load("1V9QO"),
    $00c68d69912bfe4e$var$load("j03h9"),
    $00c68d69912bfe4e$var$load("eiooB"),
    $00c68d69912bfe4e$var$load("iLyOq"),
    $00c68d69912bfe4e$var$load("h4Nf7"),
    $00c68d69912bfe4e$var$load("7f9Fz"),
    $00c68d69912bfe4e$var$load("8YSo7"),
    $00c68d69912bfe4e$var$load("lYvov"),
    $00c68d69912bfe4e$var$load("g9CVe"),
    $00c68d69912bfe4e$var$load("aeEUI"),
    $00c68d69912bfe4e$var$load("hRUX7"),
    $00c68d69912bfe4e$var$load("g4oYs"),
    $00c68d69912bfe4e$var$load("6wr18"),
    $00c68d69912bfe4e$var$load("kjZZD"),
    $00c68d69912bfe4e$var$load("3ySTn"),
    $00c68d69912bfe4e$var$load("c2rHL"),
    $00c68d69912bfe4e$var$load("awqCy"),
    $00c68d69912bfe4e$var$load("kHOMt"),
    $00c68d69912bfe4e$var$load("hhss7"),
    $00c68d69912bfe4e$var$load("6kZfp"),
    $00c68d69912bfe4e$var$load("2UbDA"),
    $00c68d69912bfe4e$var$load("nbjnv"),
    $00c68d69912bfe4e$var$load("Wowvf"),
    $00c68d69912bfe4e$var$load("ffEVr"),
    $00c68d69912bfe4e$var$load("jlSv2"),
    $00c68d69912bfe4e$var$load("1UUrt"),
    $00c68d69912bfe4e$var$load("jSdjl"),
    $00c68d69912bfe4e$var$load("l2EUC"),
    $00c68d69912bfe4e$var$load("kWZnd"),
    $00c68d69912bfe4e$var$load("92LGf"),
    $00c68d69912bfe4e$var$load("let0D"),
    $00c68d69912bfe4e$var$load("joFPh"),
    $00c68d69912bfe4e$var$load("b7jBL"),
    $00c68d69912bfe4e$var$load("kUbUu"),
    $00c68d69912bfe4e$var$load("2PePB"),
    $00c68d69912bfe4e$var$load("1W4KB"),
    $00c68d69912bfe4e$var$load("lnKog"),
    $00c68d69912bfe4e$var$load("9ftJe"),
    $00c68d69912bfe4e$var$load("h3ABO"),
    $00c68d69912bfe4e$var$load("kC80R"),
    $00c68d69912bfe4e$var$load("7EorR"),
    $00c68d69912bfe4e$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("bSdpv"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("bSdpv", function(module, exports) {

let $8a4f23dbcd20a889$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a4f23dbcd20a889$var$load("2PePB"),
    $8a4f23dbcd20a889$var$load("1W4KB"),
    $8a4f23dbcd20a889$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.3281a4c6.js.map
